/**
 * Build a public URL for a file in the Supabase 'audio' storage bucket.
 * Usage: audioUrl('01_come_a_little_closer.mp3')
 */
export function audioUrl(filename: string): string {
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
  return `${supabaseUrl}/storage/v1/object/public/audio/${filename}`;
}
